import AccountUserList from './components/AccountUserList';
import { bindActionCreators } from 'redux';
import withRouter from 'react-router-dom/withRouter'
import values from 'lodash/values';
import { connect } from 'react-redux';

import { updateUser } from '../../shared/redux/entities/actions'

function mapStateToProps(state,props){
  const users = values(state.entities.users)
    .filter((c) => c.agencyId === props.accountId)
    .sort((a,b) => {
      const first = (a.isOwner ? 'admin' : 'user' )+ (a.firstName || ''),
        second = (b.isOwner ? 'admin' : 'user' )+ (b.firstName || '');

      return first.localeCompare(second);
    });

  return {
    users:users
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({ updateUser },dispatch);
}

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(AccountUserList));



// WEBPACK FOOTER //
// ./src/routes/AccountUserList/index.js